/**
 * One-time invite token from the welcome email (`/welcome#t=<token>`).
 *
 * Imported first thing in index.js: it lifts the token out of the URL
 * fragment and scrubs the address bar before PostHog (which records the
 * current URL on its first pageview) or anything else can see it. The token
 * then lives only in this module until the welcome step redeems it.
 */
let inviteToken = null;

if (typeof window !== 'undefined' && window.location.hash) {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const t = params.get('t');
  if (t) {
    inviteToken = t;
    const { pathname, search } = window.location;
    window.history.replaceState(window.history.state, '', `${pathname}${search}`);
  }
}

export function getInviteToken() {
  return inviteToken;
}

/** Forget the token once it's been redeemed (or rejected). */
export function clearInviteToken() {
  inviteToken = null;
}
